import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, FileText } from 'lucide-react';

const Footer = () => {
  const quickLinks = [
    { name: 'About', path: '/about' },
    { name: 'Referral Interest', path: '/placement' },
    { name: 'Our Homes', path: '/homes' },
    { name: 'The Chasnell Home™', path: '/chasnell' },
    { name: 'Contact', path: '/contact' }
  ];

  const values = ['Dignity', 'Emotional Safety', 'Trust', 'Belonging'];

  return (
    <footer className="relative z-10 bg-forest-900 text-sage-100" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <h3 className="font-serif text-2xl text-cream-100 mb-3">Forever Path Living™</h3>
            <p className="font-serif italic text-gold-500 text-lg mb-5">
              Because Every Story Deserves a Forever Path™
            </p>
            <p className="text-sage-100/80 text-sm leading-relaxed mb-6">
              Forever Path Living™ is a pre-opening supportive living organization.
              Virginia DBHDS initial licensure in progress. Not currently accepting admissions.
            </p>
            <div className="flex flex-wrap gap-2">
              {values.map((v) => (
                <span
                  key={v}
                  className="px-3 py-1 bg-forest-800 rounded-full text-xs font-medium text-cream-100 border border-gold-500/20"
                >
                  {v}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.18em] text-sage-400 mb-4">Explore</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.path.slice(1)}`}
                    className="text-sage-100/85 hover:text-gold-500 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 rounded"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.18em] text-sage-400 mb-4">Get In Touch</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-xs text-sage-400 mb-0.5">Email</p>
                  <a
                    href="mailto:admin@foreverpathliving.com"
                    data-testid="footer-email-link"
                    className="text-cream-100 hover:text-gold-500 transition-colors break-all"
                  >
                    admin@foreverpathliving.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <Instagram className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-xs text-sage-400 mb-0.5">Instagram</p>
                  <a
                    href="https://instagram.com/foreverpathliving"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-instagram-link"
                    className="text-cream-100 hover:text-gold-500 transition-colors"
                  >
                    @foreverpathliving
                  </a>
                </div>
              </div>

              <div className="pt-4 border-t border-forest-800">
                <div className="flex items-start gap-2">
                  <FileText className="w-4 h-4 text-gold-500 flex-shrink-0 mt-1" />
                  <p className="text-sage-100/80 text-sm leading-relaxed">
                    To begin a conversation, please use our{' '}
                    <Link to="/placement" className="text-cream-100 hover:text-gold-500 underline font-medium">
                      referral interest form
                    </Link>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-forest-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sage-400 text-sm">© 2026 Forever Path Living™. All rights reserved.</p>
          <p className="text-sage-400 text-sm">Building relationships before opening our doors.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
